export class Primary {
  constructor() {
   this.name = 'Primary'
   this.content = {
      code: ''
    }
   this.view = this.viewHtml()
  }

  viewHtml() {
    return `<div>HTML</div>`
  }

  classes() {
    return []
  }

  styles() {
    return []
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles(),
      },
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
    }
  }
}